import React, { Component } from 'react'
import { connect } from 'react-redux'
import ic_results from '../images/ic-results.png'
class ImmunizationsLowerInfo extends Component {
    render() {
        return (
          <div>
            <div className="alert">
                {/* <h3>
                    <div class="testIcon">
                        <img src={ic_results} width="25"/>
                    </div>
                    {this.props.strings.LANDING_BOTTOM_ALERT_1}
                </h3> */}
                <p>{this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_1_1}</p>
                <p>
                    {this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_1_2}
                    <a href={this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_1_LINK} target="_blank">
                        {this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_1_LINK_TEXT}
                    </a>
                    {this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_1_3}
                </p>

                {/* this paragraph needs to be smaller */}
                <p style={{fontSize: "12px"}}>
                    {this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_2}
                </p>
            </div>
            <div className="alert hideDT">
                <p>
                    <b>
                        {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_1}
                        <a href={this.props.strings.IMMUNIZATIONS_SIDE_ALERT_1_LINK} target="_blank">
                            {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_1_LINK_TEXT}
                        </a>.
                    </b>
                </p>
                <p>
                    {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_2_1}
                    <a href={this.props.strings.IMMUNIZATIONS_SIDE_ALERT_2_LINK} target="_blank">
                        {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_2_LINK_TEXT}
                    </a>
                    {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_2_2}
                </p>
            </div>
          </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
    }
}

const ConnectedImmunizationsLowerInfo = connect(
    mapStateToProps
)(ImmunizationsLowerInfo);
export default ConnectedImmunizationsLowerInfo;
